module.exports = __webpack_public_path__ + "static/media/logo-alcantara.807d88c1.png";